import NavBarWithLogin from "../../components/header/navBarWithLogin";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useState, useCallback, useEffect } from "react";
import {
  useFetchMutateUserAccounte,
  useFetchMyUserAccount,
} from "../../common/services/liferay/apiLiferayUser";
import Loading from "../../components/elements/loading";
import { Liferay } from "../../common/services/liferay/liferay";

const MyProfile = () => {
  const navigate = useNavigate();
  const userDataSession = localStorage.getItem("userDataSession");
  const alternateNameParts = userDataSession ? userDataSession.split("-") : "";
  const identityDocument = alternateNameParts ? alternateNameParts[1] : "";
  const identityDocumentTypeId = alternateNameParts
    ? alternateNameParts[0]
    : "";
  const {
    data: fetchMyUser,
    isSuccess,
    isLoading,
    error: errorMyUser,
  } = useFetchMyUserAccount(
    sessionStorage.getItem("documentonumero") || "",
    sessionStorage.getItem("tipodedoc") || "",
    identityDocument,
    identityDocumentTypeId
  );
  const {
    mutate,
    data: dataUserSecondary,
    reset,
    isSuccess: isSuccessdUserSecondary,
    isPending: isPendingUserSecondary,
  } = useFetchMutateUserAccounte();
  const location = useLocation();
  const { payload } = location.state || {};
  const [userSantias, setUserSantias] = useState<
    | {
        names: string;
        firstSurName: string;
        secondSurName: string;
        identityDocument: number;
        identityDocumentTypeId: string;
        affiliateName: string;
        familyMembers?: any[];
      }
    | undefined
  >(undefined);
  const [profileMain, setProfileMain] = useState<
    | {
        names: string;
        firstSurName: string;
        secondSurName: string;
        identityDocument: number;
        identityDocumentTypeId: string;
        affiliateName: string;
        familyMembers?: any[];
      }
    | undefined
  >(undefined);
  const isSignedIn = Liferay.ThemeDisplay.isSignedIn();

  // Cargar profileMain desde session storage al inicializar
  useEffect(() => {
    const savedProfileMain = sessionStorage.getItem("profileMain");
    if (savedProfileMain && !profileMain) {
      try {
        setProfileMain(JSON.parse(savedProfileMain));
      } catch (error) {
        console.error("Error parsing profileMain from session storage:", error);
      }
    }
  }, [profileMain]);

  useEffect(() => {
    if (payload) {
      setUserSantias(payload);
    }
  }, [payload]);

  const handleChangeProfileClick = useCallback(
    (
      param1IdentityDocument: string,
      param2IdentityDocumentTypeId: number,
      main: boolean,
      index: number
    ) => {
      localStorage.setItem(
        "userDataSession",
        param2IdentityDocumentTypeId + "-" + param1IdentityDocument
      );
      reset();
      mutate({
        identityDocument: sessionStorage.getItem("documentonumero") || "",
        identityDocumentTypeId: sessionStorage.getItem("tipodedoc") || "",
        identityDocumentChild: param1IdentityDocument,
        identityDocumentTypeIdChild: param2IdentityDocumentTypeId.toString(),
      });
    },
    [mutate, reset]
  );

  useEffect(() => {
    if (isSuccess && fetchMyUser) {
      setUserSantias(fetchMyUser);
    }
  }, [fetchMyUser, isSuccess]);

  useEffect(() => {
    if (isSuccess && fetchMyUser && !profileMain && sessionStorage.getItem("documentonumero") === identityDocument && sessionStorage.getItem("tipodedoc") === identityDocumentTypeId) {
      setProfileMain(fetchMyUser);
      sessionStorage.setItem("profileMain", JSON.stringify(fetchMyUser));
    }
  }, [
    fetchMyUser,
    isSuccess,
  ]);

  useEffect(() => {
    if (dataUserSecondary) {
      setUserSantias(dataUserSecondary);
      navigate("/mi-perfil");
    }
  }, [dataUserSecondary, isSuccessdUserSecondary]);

  useEffect(() => {
    if (errorMyUser) {
      console.log("Error fetching user data:", errorMyUser);
      const errorMessage = errorMyUser.message;
      navigate("/mi-perfil/error-afiliado", { state: { error: errorMessage } });
    }
  }, [errorMyUser]);

  if (isLoading || isPendingUserSecondary) return <Loading />;

  if (!userSantias) return <div>No data</div>;
  return (
    <>
      <div
        data-animation="default"
        data-collapse="medium"
        data-duration="400"
        data-easing="ease"
        data-easing2="ease"
        role="banner"
        className="menu w-nav"
      >
        <NavBarWithLogin
          data={userSantias}
          isLoggedIn={isSignedIn}
          family={userSantias?.familyMembers || []}
          changeProfile={handleChangeProfileClick}
          profileMain={profileMain}
        />
      </div>
      <Outlet context={{ userSantias }} />
    </>
  );
};

export default MyProfile;
